import type { Locale as DateFnLocale } from "date-fns";
import { de } from "date-fns/locale/de";
import { enUS } from "date-fns/locale/en-US";
import { es } from "date-fns/locale/es";
import { fr } from "date-fns/locale/fr";
import { it } from "date-fns/locale/it";
import { pl } from "date-fns/locale/pl";
import { ptBR } from "date-fns/locale/pt-BR";

import type { Locale } from "../types";

export const DateLocales: { [key in Locale]: DateFnLocale } = {
  de,
  en: enUS,
  "en-PH": enUS,
  es,
  fr,
  it,
  pl,
  pt: ptBR,
};
